import {
  Box,
  Button,
  CircularProgress,
  IconButton,
  InputAdornment,
  OutlinedInput,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import loginImage from "../assets/images/dashboardLogin.gif";
import { useState } from "react";
import { positions, useAlert } from "react-alert";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import VerifyOTP from "./VerifyOTP";
import { Link } from "react-router-dom";

const Signup = () => {
  const alert = useAlert();
  const [userData, setUserData] = useState({});
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loader, setLoader] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfimPassword] = useState(false);
  const [showOtpForm, setShowOtpForm] = useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleClickShowConfirmPassword = () =>
    setShowConfimPassword((show) => !show);

  const handleChange = (label, value) => {
    setUserData((prevState) => ({ ...prevState, [label]: value }));
  };

  const validateEmail = (mail) => {
    // Check if email follows valid format
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isValidFormat = emailPattern.test(mail);

    // List of common free email domains
    const commonDomains = [
      "gmail.com",
      "yahoo.com",
      "hotmail.com",
      "outlook.com",
    ];

    // Extract the domain part of the email
    const emailDomain = mail.split("@")[1];

    // Check if the email domain is not from a free email provider (assumes it's a work email if not in the list)
    const isWorkEmail = !commonDomains.includes(emailDomain);

    return isValidFormat && isWorkEmail;
  };

  const validatePassword = (input) => {
    const hasLength = input.length >= 8;
    const hasUpperCase = /[A-Z]/.test(input); // Check for capital letter
    const hasLowerCase = /[a-z]/.test(input);
    const hasNumber = /[0-9]/.test(input); // Check for number
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(input); // Check for special character
    return (
      hasLength && hasUpperCase && hasLowerCase && hasNumber && hasSpecialChar
    );
  };

  const validatePhoneNumber = (number) => {
    const isValidPhoneNumber = /^[6-9]\d{9}$/.test(number);
    return isValidPhoneNumber;
  };

  const signUpUser = async () => {
    setLoader(true);
    const signupPayload = {
      name: userData.organization,
      email: userData.email,
      phone_number: `+91${userData.contact}`,
      username: userData.username,
      password: userData.password,
      role: "user",
      client_type: "lab",
    };

    const apiUrl =
      "https://jyxmm1ky78.execute-api.ap-south-1.amazonaws.com/Testing/client/signup";
    const options = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(signupPayload),
    };
    try {
      const response = await fetch(apiUrl, options);
      const data = await response.json();
      console.log("datatat", data);
      if (data?.isSuccess) {
        setShowOtpForm(true);
      }
    } catch (e) {
      alert.error(
        <span className="alertError">
          Something went wrong. Please try again.
        </span>,
        {
          position: positions.TOP_CENTER,
        }
      );
    }
    setLoader(false);
  };

  const submitHandler = (e) => {
    e.preventDefault();
    if (!validatePhoneNumber(userData.contact)) {
      alert.error(
        <span className="alertError">Please provide a valid phone no.</span>,
        {
          position: positions.TOP_CENTER,
        }
      );
      return;
    }
    if (!validateEmail(userData.email)) {
      alert.error(
        <span className="alertError">Please provide a valid work email</span>,
        {
          position: positions.TOP_CENTER,
        }
      );
      return;
    }
    if (!validatePassword(userData.password)) {
      {
        alert.error(
          <span className="alertError">
            Password with min 8 characters must contain atleast one capital,
            small, number and special character.
          </span>,
          {
            position: positions.TOP_CENTER,
          }
        );
        return;
      }
    }
    if (userData?.password !== confirmPassword) {
      alert.error(<span className="alertError">Passwords not matching</span>, {
        position: positions.TOP_CENTER,
      });
      return;
    }
    signUpUser();
  };

  return (
    <Box
      sx={{
        minheight: "100vh",
        padding: "18px 50px 40px",
        background: "#E9F5FE",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box>
        <img
          src="https://niroggyan.s3.ap-south-1.amazonaws.com/new-billing-dashboard-files/logos/niroggyan-logo.svg"
          alt="niroggyan logo"
          width="200px"
          height="50px"
        />
      </Box>
      <Stack direction="row" mt={4} flexGrow={1} gap={5}>
        <Box
          sx={{
            borderRadius: "30px",
            background: "#fff",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            alignSelf: "stretch",
            width: "50%",
            // height: "100%",
          }}
        >
          <img src={loginImage} alt="signup image" width="70%" />
        </Box>
        {!showOtpForm ? (
          <Box
            flexGrow={1}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Typography mb={2} variant="h6" sx={{ width: "60%" }}>
              Sign Up
            </Typography>
            <form style={{ width: "60%" }} onSubmit={submitHandler}>
              <Stack gap={1}>
                <Box>
                  <Typography variant="body6">Username</Typography>
                  <Box>
                    <TextField
                      id="outlined-basic"
                      required
                      fullWidth
                      label=""
                      variant="outlined"
                      size="small"
                      placeholder="Enter username"
                      value={userData.username || ""}
                      onChange={(e) => handleChange("username", e.target.value)}
                      sx={{ borderRadius: "12px", background: "#fff" }}
                    />
                  </Box>
                </Box>
                <Box>
                  <Typography variant="body6">Contact Number</Typography>
                  <Box>
                    <TextField
                      id="outlined-basic"
                      required
                      type="tel"
                      inputProps={{
                        maxLength: 10, // Limiting the input to 10 digits
                      }}
                      fullWidth
                      label=""
                      variant="outlined"
                      size="small"
                      placeholder="Enter your phone no."
                      value={userData.contact || ""}
                      onChange={(e) => handleChange("contact", e.target.value)}
                      sx={{ borderRadius: "12px", background: "#fff" }}
                    />
                  </Box>
                </Box>
                <Box>
                  <Typography variant="body6">Organization</Typography>
                  <Box>
                    <TextField
                      id="outlined-basic"
                      required
                      fullWidth
                      label=""
                      variant="outlined"
                      size="small"
                      placeholder="Enter your org name"
                      value={userData.organization || ""}
                      onChange={(e) =>
                        handleChange("organization", e.target.value)
                      }
                      sx={{ borderRadius: "12px", background: "#fff" }}
                    />
                  </Box>
                </Box>
                <Box>
                  <Typography variant="body6">Work Email</Typography>
                  <Box>
                    <TextField
                      id="outlined-basic"
                      type="email"
                      required
                      fullWidth
                      label=""
                      variant="outlined"
                      size="small"
                      placeholder="Enter work email"
                      value={userData.email || ""}
                      onChange={(e) => handleChange("email", e.target.value)}
                      sx={{ borderRadius: "12px", background: "#fff" }}
                    />
                  </Box>
                </Box>
                <Box>
                  <Typography variant="body6">Password</Typography>
                  <Box>
                    {/* <TextField
                    fullWidth
                    type="password"
                    required
                    id="outlined-basic"
                    label=""
                    variant="outlined"
                    size="small"
                    placeholder="At lease 8 characters"
                    value={userData.password || ""}
                    onChange={(e) => handleChange("password", e.target.value)}
                    sx={{ borderRadius: "12px", background: "#fff" }}
                  /> */}
                    <OutlinedInput
                      id="outlined-adornment-password"
                      size="small"
                      placeholder="Enter at least 8 characters"
                      fullWidth
                      type={showPassword ? "text" : "password"}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            // onMouseDown={handleMouseDownPassword}
                            // onMouseUp={handleMouseUpPassword}
                            edge="end"
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      }
                      label=""
                      style={{ background: "#fff" }}
                      value={userData.password || ""}
                      onChange={(e) => handleChange("password", e.target.value)}
                    />
                  </Box>
                </Box>
                <Box>
                  <Typography variant="body6">Confirm password</Typography>
                  <Box>
                    {/* <TextField
                    fullWidth
                    required
                    type="password"
                    id="outlined-basic"
                    label=""
                    variant="outlined"
                    size="small"
                    placeholder="At lease 8 characters"
                    value={confirmPassword}
                    onChange={(e) =>
                      handleChange(setConfirmPassword(e.target.value))
                    }
                    sx={{ borderRadius: "12px", background: "#fff" }}
                  /> */}
                    <OutlinedInput
                      id="outlined-adornment-password"
                      size="small"
                      placeholder="Enter at least 8 characters"
                      fullWidth
                      type={showConfirmPassword ? "text" : "password"}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowConfirmPassword}
                            // onMouseDown={handleMouseDownPassword}
                            // onMouseUp={handleMouseUpPassword}
                            edge="end"
                          >
                            {showConfirmPassword ? (
                              <VisibilityOff />
                            ) : (
                              <Visibility />
                            )}
                          </IconButton>
                        </InputAdornment>
                      }
                      label=""
                      style={{ background: "#fff" }}
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                    />
                  </Box>
                </Box>
              </Stack>
              <Box mt={3}>
                <Button sx={{ width: "100%" }} type="submit">
                  {loader ? (
                    <CircularProgress size="30px" color="inherit" />
                  ) : (
                    "Sign Up"
                  )}
                </Button>
              </Box>
              <Typography
                mt={2}
                variant="body4"
                sx={{ textAlign: "center", color: "#475467", display: "block" }}
              >
                Already have an account?{" "}
                <span>
                  <Link style={{ textDecoration: "underline" }} to="/login">
                    Login
                  </Link>
                </span>
              </Typography>
            </form>
          </Box>
        ) : (
          <VerifyOTP
            username={userData.username}
            showOtpForm={showOtpForm}
            setShowOtpForm={setShowOtpForm}
          />
        )}
      </Stack>
    </Box>
  );
};

export default Signup;
